import React, {ReactElement} from 'react';

import {ChevronUpDownIcon} from '../../../../resources/Icons';
import Row from '../../../common/Row';
import {SortOrder} from '../../marketplace/types';
import Select from '../Select';

type Props = {
  order?: string;
  options: (keyof typeof SortOrder)[];
  onChange: (order: keyof typeof SortOrder) => void;
  className?: string;
};

const SortDropdown = ({order, options, onChange, className}: Props): ReactElement => {
  const sortOrder = options.find(option => option === order);
  const description = sortOrder ? SortOrder[sortOrder] : '...';

  return (
    <Select
      variant={'secondary'}
      floating
      hideChevron
      buttonContent={
        <Row className={'items-center whitespace-nowrap'}>
          <div>
            Sort by <span className={'text-primary-600'}>{description}</span>
          </div>
          <ChevronUpDownIcon className={'inline w-[15px] h-[15px] text-primary-600 ml-[4px]'} />
        </Row>
      }
      className={className}
      options={options.map(option => ({
        value: option,
        label: SortOrder[option],
      }))}
      selectedValues={sortOrder ? [sortOrder] : []}
      onOptionSelected={onChange}
    />
  );
};

export default SortDropdown;
